interface Props {
  color?: string
  width?: number
  height?: number
}

export const BottomAlignIcon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.3945 19.8945C20.6706 19.8946 20.8945 20.1185 20.8945 20.3945C20.8945 20.6706 20.6706 20.8945 20.3945 20.8945H0.5C0.223858 20.8945 0 20.6707 0 20.3945C5.56666e-05 20.1184 0.223892 19.8945 0.5 19.8945H20.3945ZM14.3164 0C14.5922 0.00038874 14.8164 0.224098 14.8164 0.5V15.9736C14.8164 16.2495 14.5922 16.4732 14.3164 16.4736H6.5791C6.30299 16.4736 6.07916 16.2497 6.0791 15.9736V0.5C6.0791 0.223858 6.30296 0 6.5791 0H14.3164ZM7.0791 15.4736H13.8164V1H7.0791V15.4736Z"
        fill={color}
      />
    </svg>
  )
}
